/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/receipts';

export const ReceiptApi = {
  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createCollectDebt: async (billID: string, body: any) => {
    try {
      const response = await entityService.post(
        `${pathname}/collect-debt/${billID}`,
        body
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async (option: { type: number }) => {
    try {
      let url = `${pathname}/generate-code`;
      const query = serialize(option);
      url += query;

      const response = await entityService.get(url);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicateCode: async (option: checkDuplicateReceiptCodeOption) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createCustomerCollectDebt: async (debtID: string, body: any) => {
    try {
      const response = await entityService.post(
        `${pathname}/customer/collect-debt/${debtID}`,
        body
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createCustomerCollectDebtByCollaborator: async (
    debtID: string,
    body: any
  ) => {
    try {
      const response = await entityService.post(
        `${pathname}/customer/collect-collaborator-debt/${debtID}`,
        body
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findOneForUpdate: async (id: string) => {
    const url = `${pathname}/for-update/${id}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerReceipt: async (option: any) => {
    let url = `${pathname}/customer-receipt`;

    const {
      ownerIDs,
      entityIDs,
      assigneeIDs,
      startedAt,
      finishedAt,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        ownerIDs,
        entityIDs,
        startedAt,
        finishedAt,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  findSupplierPayment: async (option: any) => {
    let url = `${pathname}/supplier-payment`;

    const {
      ownerIDs,
      entityIDs,
      assigneeIDs,
      startedAt,
      finishedAt,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        ownerIDs,
        entityIDs,
        startedAt,
        finishedAt,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface checkDuplicateReceiptCodeOption {
  entityID: string;
  code: string;
}
